import React, { useRef, useEffect } from "react";
import Chart from "chart.js/auto";
import { Tag } from "antd";
import { useMediaQuery } from "@material-ui/core";

type RiskLevelData = {
  green: number;
  yellow: number;
  orange: number;
  red: number;
};

type Props = {
  riskLevels: any;
  tags?: any;
};

const HiraRiskLevelChart = ({ riskLevels, tags }: Props) => {
  const matches = useMediaQuery("(min-width:820px)");
  const smallScreen = useMediaQuery("(min-width:470px)");
  const chartRef = useRef<any>(null);

  useEffect(() => {
    console.log("checkdashboard riskLeveles", riskLevels);

    const ctx = chartRef.current.getContext("2d");
    if (chartRef.current) {
      const labels = ["green", "yellow", "orange", "red"];
      const colors = ["#55BF3B", "#DDDF0D", "#FFA500", "#DF5353"];
      const hoverColors = ["#47a03e", "#CCCC0D", "#FF9000", "#CF3533"];

      // Explicitly match keys to labels
      const riskData = {
        green: riskLevels?.green,
        yellow: riskLevels?.yellow,
        orange: riskLevels?.orange,
        red: riskLevels?.red,
      };

      const filteredData = labels
        .map((label, index) => ({
          label,
          value: riskData[label as keyof RiskLevelData], // Ensure correct matching
          color: colors[index],
          hoverColor: hoverColors[index],
        }))
        .filter((item: any) => item.value > 0);
      const chart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: filteredData?.map((item) => item?.label),
          datasets: [
            {
              data: filteredData?.map((item) => item?.value),
              backgroundColor: filteredData?.map((item) => item?.color),
              hoverBackgroundColor: filteredData?.map(
                (item) => item?.hoverColor
              ),
            },
          ],
        },
        options: {
          circumference: 180,
          rotation: -90,
          cutout: "50%",
          maintainAspectRatio: true,
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: "right",
              labels: {
                generateLabels: function (chart) {
                  const originalLabels = ["Low", "Medium", "High", "Severe"];
                  const labels = chart?.data?.labels || [];
                  const dataset = chart?.data?.datasets[0] || {
                    backgroundColor: [],
                  };
                  const backgroundColors: any = dataset?.backgroundColor || [];
                  return labels.map((label, index) => ({
                    text: originalLabels[index] || "",
                    fillStyle: backgroundColors[index] || "transparent",
                    hidden: !chart.getDataVisibility(index),
                    index: index,
                  }));
                },
              },
            },
            datalabels: {
              color: "white", // Change the color of data labels
              font: {
                size: 14, // Increase the size of data labels
              },
            },
            title: {
              display: true,
              text: "Risk Steps by Score",
              font: {
                size: 16,
                weight: "1",
                family: "'Poppins', sans-serif", // Change the font family here
              },
              align: "center",
              color: "black",
              padding: {
                top: 10, // Adjust this value to reduce the gap further
                bottom: -20, // Adjust this value to reduce the gap further
              },
            },
            tooltip: {
              enabled: true,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              borderColor: "#fff",
              borderWidth: 1,
              titleFont: {
                size: 16, // Increase font size
                weight: "bold",
              },
              bodyFont: {
                size: 14, // Increase font size
                weight: "normal",
              },
              padding: 10, // Add more padding
            },
            // tooltip: {
            //   enabled: true,
            //   callbacks: {
            //     label: function (tooltipItem) {
            //       return `${tooltipItem.label}: ${tooltipItem.raw}`;
            //     },
            //   },
            // },
          },
        },
      });

      return () => {
        chart.destroy();
      };
    }
  }, [riskLevels]); // Adding riskLevels to dependency array so chart updates if the data changes

  return (
    <div
      style={{
        cursor: "not-allowed", // Set cursor style
        // pointerEvents: "none",
      }}
    >
      {matches ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {tags?.length ? (
            <>
              {tags?.map((tag: any, index: any) => (
                <Tag color={tag.color} key={index}>
                  {tag.tagName}
                </Tag>
              ))}
            </>
          ) : (
            <></>
          )}
        </div>
      ) : null}
      <canvas
        style={{
          width: "300px",
          height: "300px",
          cursor: "not-allowed", // Set cursor style
          pointerEvents: "none",
        }}
        ref={chartRef}
      />
    </div>
  );
};

export default HiraRiskLevelChart;
